let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("4r1UM")]).then(() => parcelRequire('jlQix'));